<template>
  <div class="container-fluid">
    <Header />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/header";
import Footer from "./components/footer";

export default {
  components: { Header, Footer },
  data() {
    return {
      fullURL: window.location,
    };
  },
  mounted() {},
  computed: {
    isP2U() {
      // return true;
      return window.location.toString().indexOf("preeti.lokpath.com") >= 0;
    },
  },
  name: "App",
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Mukta:wght@500&display=swap");

@font-face {
  font-family: "Preeti"; /*a name to be used later*/
  src: url("../public/preeti.TTF"); /*URL to font*/
}

:root {
  --color_primary: #a73639;
  --color_secondary: #0893c8;
}

#preeti {
  font-family: "Preeti";
  font-weight: 800;
}
#unicode {
  /* font-family: "Mukta", sans-serif; */
  /* font-family: "Times New Roman", Times, serif; */
}
.container {
  /* padding: 0px 20vw; */
}
.heading {
  color: var(--color_primary);
}
.navbar {
  background-color: var(--color_primary);
}
.navbar li {
  margin: 0px 10px;
}

.jumbotron {
  padding: 20px 0px;
}
#preeti {
  font-family: "Preeti";
  font-size: 1.5em;
}
#unicode {
  font-size: 1.5em;
}
label {
  padding: 5px;
}
.spacer {
  background-color: #dddc;
}
.title {
  background-color: var(--color_secondary);
}

@media screen and (min-width: 1000px) {
  .wrapper {
    padding: 0px 100px;
  }
}
</style>
